import React, { useContext } from "react"
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import { Reservation } from "../pages/Reservation";
import { ReservationComplete } from "../pages/ReservationComplete";
import { NewContactPage } from "../pages/NewContactPage";
import { ContactCompletePage } from "../pages/ContactComplete";
import { BridalFairs } from "../pages/BridalFairs";
import { FairDetail } from "../pages/FairDetail";
import { ParticipationNew } from "../pages/ParticipationNew";
import { FairTimeShowCompletePage } from "../pages/FairTimeShowComplete";
import { PickupParticularFairs } from "../pages/BridalFairs/PickupParticularFairs";
import { ScrollToTop } from "../components/ui-parts/ScrollToTop";
import { BridalPlans } from "../pages/BridalPlans";
import { BridalPlan } from "../pages/BridalPlan";

export const ROUTING_PATH = {
  RESERVATION: "/customer/public/reservation_pages/:reservationPageKey/schedule_appointments",
  RESERVATION_COMPLETE: "/customer/public/reservation_pages/:reservationPageKey/thanks_appointment",
  CONTACT: "/customer/public/contact_pages/:contactPageKey",
  CONTACT_COMPLETE: "/customer/public/contact_pages/:contactPageKey/thanks_contact",
  RECOMMENDED_FAIRS: "/customer/public/bridal_fair_pages/:bridalFairPageKey/recommended_fairs",
  PICKUP_PARTICULAR_FAIRS: "/customer/public/bridal_fair_pages/:bridalFairPageKey/pickup_fairs",
  BRIDAL_FAIR_PAGES_FAIRS: "/customer/public/bridal_fair_pages/:bridalFairPageKey/fairs",
  BRIDAL_FAIR_PAGES_FAIR_SHOW: "/customer/public/bridal_fair_pages/:bridalFairPageKey/fairs/:bridalFairDetailKey",
  BRIDAL_FAIR_PAGES_FAIR_PARTICULAR_SHOW: "/customer/public/bridal_fair_pages/:bridalFairPageKey/fairs/:bridalFairDetailKey/particular_dates/:particularDate",
  BRIDAL_FAIR_PAGES_PARTICIPATION_NEW: "/customer/public/bridal_fair_pages/:bridalFairPageKey/fairs/:bridalFairDetailKey/fair_times/:startAt/participations/new",
  BRIDAL_FAIR_PAGES_PARTICIPATION_COMPLETE: "/customer/public/bridal_fair_pages/:bridalFairPageKey/thanks_participation",
  BRIDAL_FAIR_DETAIL_SHOW: "/customer/public/bridal_fair_details/:bridalFairDetailKey",
  BRIDAL_FAIR_PARTICULAR_DETAIL_SHOW: "/customer/public/bridal_fair_details/:bridalFairDetailKey/particular_dates/:particularDate",
  BRIDAL_FAIR_DETAILS_PARTICIPATION_NEW: "/customer/public/bridal_fair_details/:bridalFairDetailKey/fair_times/:startAt",
  BRIDAL_FAIR_DETAILS_PARTICIPATION_COMPLETE: "/customer/public/bridal_fair_details/:bridalFairDetailKey/thanks_participation",
  BRIDAL_FAIR_PAGES_PLANS: "/customer/public/bridal_fair_pages/:bridalFairPageKey/plans",
  BRIDAL_FAIR_PAGES_PLAN: "/customer/public/bridal_fair_pages/:bridalFairPageKey/plans/:id",
} as const

const router = createBrowserRouter([
  {
    path: ROUTING_PATH.RESERVATION,
    element: <Reservation />,
  },
  {
    path: ROUTING_PATH.RESERVATION_COMPLETE,
    element: <ReservationComplete />,
  },
  {
    path: ROUTING_PATH.CONTACT,
    element: <NewContactPage />,
  },
  {
    path: ROUTING_PATH.CONTACT_COMPLETE,
    element: <ContactCompletePage />,
  },
  {
    path: ROUTING_PATH.BRIDAL_FAIR_PAGES_FAIRS,
    element: <ScrollToTop><BridalFairs /></ScrollToTop>,
  },
  {
    path: ROUTING_PATH.BRIDAL_FAIR_PAGES_FAIR_SHOW,
    element: <ScrollToTop><FairDetail /></ScrollToTop>,
  },
  {
    path: ROUTING_PATH.BRIDAL_FAIR_PAGES_PARTICIPATION_NEW,
    element: <ScrollToTop><ParticipationNew /></ScrollToTop>,
  },
  {
    path: ROUTING_PATH.BRIDAL_FAIR_DETAIL_SHOW,
    element: <FairDetail />,
  },
  {
    path: ROUTING_PATH.BRIDAL_FAIR_DETAILS_PARTICIPATION_NEW,
    element: <ParticipationNew />,
  },
  {
    path: ROUTING_PATH.BRIDAL_FAIR_PAGES_PARTICIPATION_COMPLETE,
    element: <ScrollToTop><FairTimeShowCompletePage /></ScrollToTop>,
  },
  {
    path: ROUTING_PATH.BRIDAL_FAIR_DETAILS_PARTICIPATION_COMPLETE,
    element: <ScrollToTop><FairTimeShowCompletePage /></ScrollToTop>,
  },
  {
    path: ROUTING_PATH.PICKUP_PARTICULAR_FAIRS,
    element: <PickupParticularFairs />,
  },
  {
    path: ROUTING_PATH.RECOMMENDED_FAIRS,
    element: <PickupParticularFairs />,
  },
  {
    path: ROUTING_PATH.BRIDAL_FAIR_PAGES_PLANS,
    element: <ScrollToTop><BridalPlans /></ScrollToTop>
  },
  {
    path: ROUTING_PATH.BRIDAL_FAIR_PAGES_PLAN,
    element: <ScrollToTop><BridalPlan /></ScrollToTop>
  },
])


const ConfigContext = React.createContext(null);

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return context;
};

const ConfigProvider = ConfigContext.Provider;

// @ts-expect-error TS7006 ref: https://taian.atlassian.net/browse/OIM-990
export const AppRoutes = (props) => {
  const { config } = props;
  return (
    <ConfigProvider value={config}>
      <RouterProvider router={router} />
    </ConfigProvider>
  )
}
